let isDev = true;

let config = {
    dev: {
        apiDomain: 'https://flyhighdevapi.cubalto.com',
        memberDomain: 'https://memberdevapi.cubalto.com',
        searchElaUrl: 'http://search-justreet-dev-7sub6fesdbgbvimnjh2zxmn6hu.ap-northeast-2.es.amazonaws.com',
    },
    prod: {
        apiDomain: "https://flyhighapi.cubalto.com",
        memberDomain: 'https://memberapi.cubalto.com',
        searchElaUrl: 'https://search-justreet-vsbimxrprp4vurj3mxyh4jh3wi.ap-northeast-2.es.amazonaws.com',
    },
}
function getConfig(key='apiDomain') {
    return isDev ? config.dev[key] : config.prod[key];
}

function setConfig(key, value) {
    if(isDev) {
        config.dev[key] = value;
    }else{
        config.prod[key] = value;
    }
}

function setterApiDomain(domain) {
    setConfig('apiDomain', domain);
    apiDomain = getConfig('apiDomain');
    apiURL = `${getConfig('apiDomain')}/api/`;
}

let apiDomain = getConfig('apiDomain')
let searchElaUrl = getConfig('searchElaUrl')
let apiURL = `${getConfig('apiDomain')}/api/`;
let memberDomain = getConfig('memberDomain')
let memberApiURL = `${getConfig('memberDomain')}/api/`

export {apiURL, apiDomain, searchElaUrl, memberDomain, memberApiURL,setterApiDomain };

